module.exports = __webpack_public_path__ + "static/media/32filter.000db2d6.svg";